import { PP_TYPE } from 'MODULES/PP_TYPE';

export const getCategoryIdFromPath = (path) => {
    if (new RegExp('category').test(path)) {
        return new RegExp('(\\d+)(?!.*\\d)').exec(path)[0];
    }

    return PP_TYPE.list;
};
